import React, { useState } from "react";
import PropTypes from "prop-types";
import Grid from "../../../../components/Grid";
import { sortGridByColumn } from "../../../../utils";
import { LoadingIndicator } from "../../../../components";

const RlCloudSandboxGrid = ({
  data,
  schema,
  onPageChange,
  pageSize = 30,
  showLoading = false,
  hidePaging = false
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [sort, setSort] = useState({
    field: "default",
    direction: "asc"
  });
  const count = data?.length;

  const viewData = data?.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const handleSortChange = sortParams => {
    const { field, direction } = sort;
    if (sortParams.direction === direction && sortParams.field === field)
      return;
    setSort(sortParams);
    sortGridByColumn(data, sortParams);
  };

  const handlePageChange = pageData => {
    setCurrentPage(pageData);
    onPageChange?.((pageData - 1) * pageSize, pageData * pageSize);
  };

  return (
    <Grid
      schema={schema}
      data={viewData}
      totalResults={count}
      page={currentPage}
      pageSize={pageSize}
      numPages={Math.ceil(count / pageSize)}
      onPageChange={handlePageChange}
      showPageNumbers
      hidePaging={hidePaging}
      sort={sort}
      onSortChange={handleSortChange}
      showLoading={showLoading}
      LoadingComponent={<LoadingIndicator style={{ margin: "5rem 0" }} />}
    />
  );
};

RlCloudSandboxGrid.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape()),
  schema: PropTypes.shape({
    fields: PropTypes.arrayOf(
      PropTypes.shape({
        displayTitle: PropTypes.node,
        name: PropTypes.string,
        sortable: PropTypes.bool,
        component: PropTypes.func
      })
    )
  }),
  onPageChange: PropTypes.func,
  pageSize: PropTypes.number,
  showLoading: PropTypes.bool,
  hidePaging: PropTypes.bool
};

export default RlCloudSandboxGrid;
